import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { DEEP_BORDER_BOX } from 'common';

const { RADIUS } = Tokens;

const SMALL_SIZE_CONTENT = '0.875rem';
const BUTTON_INNER_SHADOW_WIDTH = '0.125rem';
const BUTTON_INNER_SHADOW_WIDTH_SMALL = '0.063rem';

const SMALL_BUTTON_STYLE = {
  width: '1.25rem',
  minWidth: '1.25rem',
  height: '1.25rem'
};

const NORMAL_BUTTON_STYE = {
  width: '2rem',
  minWidth: '2rem',
  height: '2rem'
};


const ICON_BUTTON_FOCUSED = css`
  :focus {
    outline: none;
    box-shadow: inset 0 0 0 ${({ $size }) => $size === 'small' ? BUTTON_INNER_SHADOW_WIDTH_SMALL : BUTTON_INNER_SHADOW_WIDTH} ${props => props.$theme.focused.border};
    & svg * {
      fill: ${props => props.$theme.focused.content};
    }
  }
`;

const ICON_BUTTON_HOVERED = css`
  :hover:not(:disabled) {
    outline: none;
    background-color: ${props => props.$theme.hovered.container};
    & svg * {
      fill: ${props => props.$theme.hovered.content};
    }
  }
`;

const ICON_BUTTON_DISABLED = css`
  :disabled {
    cursor: initial;
    background-color: ${props => props.$theme.disabled.container};
    & svg * {
      fill: ${props => props.$theme.disabled.content};
    }
  }
`;

const SMALL_ICON_SIZE = css`
  & *:not(svg):not(path) {
    max-width: ${SMALL_SIZE_CONTENT};
    max-height: ${SMALL_SIZE_CONTENT};
  }
`;

export default {
  IconButton: styled.button`
    ${DEEP_BORDER_BOX}
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    display: inline-block;
    padding: 0;
    ${props => (props.$size === 'small' ? SMALL_BUTTON_STYLE : NORMAL_BUTTON_STYE)}
    flex: 0 0 auto;
    margin: 0;
    background-color: ${props => props.$theme.container};
    outline: none;
    cursor: pointer;
    overflow: hidden;
    border: 0;
    border-radius: ${RADIUS.RADIUS_CIRCLE};
    & span * {
      fill: ${props => props.$theme.content};
      margin: 0;
    }
    ${ICON_BUTTON_HOVERED}
    ${ICON_BUTTON_FOCUSED}
    ${ICON_BUTTON_DISABLED}
    ${({ $size }) => $size === 'small' ? SMALL_ICON_SIZE : css``}
  `
};
